import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { kebabCase } from "lodash"
import { Dialog } from '@headlessui/react'
import { XMarkIcon } from "@heroicons/react/24/outline"

export default function Subscribe({ location }) {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        footer {
          subscribe {
            heading
            description
            subtext
          }
        }
      }
    }
  `)
  const { heading, description, subtext } = data?.wpOption?.footer?.subscribe
  // const [is21, setIs21] = useState(false)
  let [isOpen, setIsOpen] = useState(location?.search?.includes("subscribe") ? true : false)

  return (
    <div
      id="subscribe"
      className={`form-subscribe print:hidden py-9 md:py-16 bg-banner-gradient/5`}
    >
      <div className="container">
        {heading ? <h2 id={kebabCase(heading)} className="text-center mb-2 max-w-4xl mx-auto">{heading}</h2> : null}
        {description ? <div className="text-center mb-6 max-w-4xl mx-auto">{description}</div> : null}
        {/* <form
          name="subscribe"
          method="POST"
          netlify-honeypot="bot-field"
          data-netlify="true"
          className="mb-6"
          action="/thank-you-newsletter"
        >
          <input type="hidden" name="form-name" value="subscribe" />
          <p className="hidden">
            <label>
              Don’t fill this out if you’re human: <input name="bot-field" />
            </label>
          </p>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 max-w-4xl gap-4 mx-auto">
            <input
              type="text"
              className="form-field"
              placeholder="First name"
              aria-label="First name"
              name="FirstName"
              autoComplete="given-name"
              required
            />
            <input
              type="text"
              className="form-field"
              placeholder="Last name"
              aria-label="Last name"
              name="LastName"
              autoComplete="family-name"
              required
            />
            <input
              type="email"
              className="form-field"
              placeholder="Email address"
              aria-label="Email address"
              name="Email"
              autoComplete="email"
              required
            />
            <button
              type="submit"
              className={`btn-sm btn-primary py-4 ${is21 ? '' : 'disabled'}`}
              disabled={!is21}
            >
              Submit
            </button>
          </div>
          <div className="flex items-center justify-center mt-2">
          <label className="flex flex-row-reverse items-center">Are you 21 or older? <input
            type="checkbox"
            className="form-checkbox mr-1.5"
            name="Are you 21 or older?"
            required
            onChange={() => setIs21(!is21)}
          /></label>
          </div>
        </form> */}
        {/* <iframe loading="lazy" className="w-full h-[428px]" src={"/jamul-acoustic-unedited.html"} title={heading}></iframe> */}
        {/* <iframe loading="lazy" className="w-full h-[428px]" src={"/jamul-acoustic.html"} title={heading}></iframe> */}
        <div className="mb-4 text-center">
          <button className="btn btn-primary" onClick={() => setIsOpen(true)}>Subscribe</button>
        </div>
        <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
          <div className="fixed inset-0 bg-black/30 z-30" aria-hidden="true" />
          <div className="fixed inset-0 flex items-center justify-center p-4 z-30">
            <Dialog.Panel className="mx-auto max-w-md min-h-[650px] max-h-screen w-full rounded bg-white relative">
              <iframe loading="lazy" className="w-full h-[650px]" src="https://content-us-1.content-cms.com/api/1481a1d0-d03f-4fd8-bdd2-67ab0b393c8f/forms/460341364452196352" title={heading}></iframe>
              <button aria-label="Close subscribe form dialog" className="absolute top-4 right-4" onClick={() => setIsOpen(false)}><XMarkIcon className="w-6" /></button>
            </Dialog.Panel>
          </div>
        </Dialog>
        {subtext ? <div className="text-center max-w-2xl mx-auto text-gray-500">{subtext}</div> : null}
      </div>
    </div>
  )
}
